import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import Swal from 'sweetalert2';
import { get_token, get_user_details } from "@/router";
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';
import { client_domain } from "@/main.js";


export default {
  components: {
    Sidebar,
    Navbar,
    InactivityModal
  },
  data() {
    return ({
      users: [],
      portal_name: '',
      edit_is_master: false,
      edit_portal_id: null,
      edit_description: '',
      edit_portal: '',
      isEditMode: false,
      school_domain: false,
  
      // Portal visibility
      is_public: true,
      selectedVisibility: 'public',
  
      // Portal types
      portal_types: [],
      selectedPortalType: null,
  
      // Master/sub portal config
      isMaster: false,
      selectedMasterPortal: '',
      selectedPortals: [],
  
      // Contact email (for incident portals)
      contactEmail: '',
  
      // User selection for private portals
      selectedUserIds: [],
  
      // Portal list and loading state
      portals: [],
      isLoading: false,
  
      // Form validation
      errors: {},
      searchQuery:"",
  
      // Submission state
      isSubmitting: false,
    });
  },
  computed: {
    isPublic() {
      return this.selectedVisibility === 'public';
    },

    portals_for_selection() {
    return this.portals.filter(portal => 
      !portal.portal_type || portal.portal_type.name !== 'incident'
    );
  },
    areAllSelected() {
      if (!Array.isArray(this.selectedPortals) || !Array.isArray(this.filteredPortals)) {
        return false;
      }

      const filteredIds = this.filteredPortals.map(p => p.id);
      return filteredIds.length > 0 && filteredIds.every(id => this.selectedPortals.includes(id));
    },
    all_sub_portal_selected() {
    const availableIds = this.portals_for_selection.map(p => p.id);
    return availableIds.length > 0 && availableIds.every(id => this.selectedPortals.includes(id));
  }

  },
  methods: {

    getToken() {
      return get_token();
    },
    toggleSidebar() {
      this.$refs.sidebar.$el.classList.toggle("close");
    },
    validationPortalForm() {
      this.errors = {};
      let valid = true;

      if (!this.portal_name) {
        this.errors.portal_name = 'Portal name is required';
        valid = false;
      }

      if (!this.selectedPortalType?.id) {
        this.errors.portal_type = 'Portal type is required';
        valid = false;
      }

      return valid;
    },
    set_default_portal_type() {
      if (!this.portal_types.length) {
        this.selectedPortalType = null;
        return;
      }

      if (this.school_domain) {
        this.selectedPortalType = this.portal_types.find(
          type => type.name && type.name.toLowerCase().trim() === 'engagement'
        ) || this.portal_types[0];
        return;
      }

      this.selectedPortalType = this.portal_types[0];
    },
    resetPortalForm() {
      this.portal_name = '';
      this.edit_description = '';
      this.selectedPortals = [];
      this.selectedUserIds = [];
      this.contactEmail = '';
      this.isMaster = false;
      this.isPublic = false;
      this.selectedMasterPortal = null;
      this.isSubmitting = false;
      this.errors = {};
      this.set_default_portal_type();
    },
    toggleSelectAll() {
        // Use the source of truth for your table rows
        const all_ids = this.users.map(user => user.id);

        if (this.areAllSelected) {
          // If all are currently selected, clear the selection
          this.selectedUserIds = [];
        } else {
          // Otherwise, set selectedUserIds to all available IDs
          this.selectedUserIds = [...all_ids];
        }
      },
      add_member_modal_open() {
      $('#create_portal').modal('hide');

      $('#create_portal').one('hidden.bs.modal', () => {
        $('#portal_member_modal').modal('show');
      });
    },
    add_member_modal_close() {
      $('#portal_member_modal').modal('hide');

      $('#portal_member_modal').one('hidden.bs.modal', () => {
        $('#create_portal').modal('show');
      });
    },

    sub_portal_modal_open() {
    $('#create_portal').modal('hide');
    $('#create_portal').one('hidden.bs.modal', () => {
      $('#select_portals_modal').modal('show');
    });
  },

  sub_portal_modal_close() {
    $('#select_portals_modal').modal('hide');
    $('#select_portals_modal').one('hidden.bs.modal', () => {
      $('#create_portal').modal('show');
    });
  },
    toggleSelectAllSubPortals() {
    // Getting IDs from the base list used in the table
    const allIds = this.portals_for_selection.map(p => p.id);
    if (this.all_sub_portal_selected) {
      this.selectedPortals = [];
    } else {
      this.selectedPortals = [...allIds];
    }
  },

    confirmSelectedPortals() {
      $('#select_portals_modal').modal('hide');
    },
    openCreateModal() {
      this.isEditMode = false;
      this.resetPortalForm();
      $('#create_portal').modal('show');
    },
    openEditModal(portal) {
      this.isEditMode = true;
      this.edit_portal_id = portal.id;
      this.portal_name = portal.name;
      this.edit_description = portal.description || '';
      this.selectedPortalType = this.portal_types.find(
        t => t.id === portal.portal_type.id
      ) || null;
    
      this.isMaster = portal.is_master? true : false;
      this.selectedPortals = portal.sub_portals || [];
      this.selectedMasterPortal = portal.master_portal.id || null;
      this.selectedVisibility = portal.is_public ? 'public' : 'private';
      this.selectedUserIds = portal.member_ids || [];
      $('#create_portal').modal('show');
    },

    createPortal() {
      if (!this.validationPortalForm()) return;
      this.isSubmitting = true;
  
      if (this.isEditMode) {
        this.submitUpdatePortal();
      } else {
        this.submitCreatePortal();
      }
    },
    submitUpdatePortal() {
      let baseUrl = '';

      if (this.selectedPortalType.name === 'publishing') {
        baseUrl = '/publish_portal';
      } else {
        baseUrl = '/view_portal';
      }

      const payload = {
        portal_id: this.edit_portal_id,
        update_values: {
          name: this.portal_name,
          description: this.edit_description || 'null',
          is_master: this.isMaster ? 'True' : 'False',
          master_portal_id: this.selectedMasterPortal || null,
          is_public: this.isPublic ? 'True' : 'False',
          portal_type_id: this.selectedPortalType?.id || null
        },
        user_id: this.selectedUserIds || [],
        contact_email: this.contactEmail || null,
        portal_ids: this.selectedPortals || [],
        base_url: baseUrl,
      };

      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_portal_api/`,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        success: (response) => {
          if (response.status === "success") {
            Swal.fire({ icon: 'success', title: 'Updated', timer: 3000, showConfirmButton: false ,
            position: 'bottom-end',
            toast: true
            });
            $('#create_portal').modal('hide');
            this.fetchPortals(); // or manually update the local list
          }
        },
        complete: () => {
          this.resetPortalForm();
        }
      });
    },

    submitCreatePortal() {
      const formData = new FormData();
      formData.append('portal_name', this.portal_name);
      formData.append('portal_type', this.selectedPortalType.id);
      formData.append('is_master', this.isMaster);
      formData.append('master_portal_id', this.selectedMasterPortal ?? '');
      formData.append('contact_email', this.contactEmail);
      formData.append('is_public', this.selectedVisibility === 'public');
      this.selectedPortals.forEach(id => formData.append('sub_portals', id));
      this.selectedUserIds.forEach(id => formData.append('user_id', id));

      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_portal_api/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {
          if (response.status === "success") {
            Swal.fire({ icon: 'success', title: 'Created', timer: 1000, showConfirmButton: false ,
            position: 'bottom-end',
            toast: true
            });
            $('#create_portal').modal('hide');
           this.portals.push(response.portal);
          }
        },
        error: (response) => {
          const error = response.responseJSON;
          if (error.status === "error") {
            this.errors.portal_name = error.message;
          }
        },
        complete: () => {
          this.resetPortalForm();
        }
      });
    },

    fecthPortalTypes() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_types`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          var status = response.status
          if (status == "success") {
            this.portal_types = response.portal_types.filter(
              type => type.name.toLowerCase() !== 'default'
            );
            if (!this.selectedPortalType?.id) {
              this.set_default_portal_type();
            }
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },

    fetchPortals() {
      this.isLoading = true;
    
      return new Promise((resolve) => {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_portals_api/`,
          method: 'POST',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          success: (data) => {
            this.portals = data.portals;
            this.portals = this.portals.filter(
                  portal => portal.name?.toLowerCase() !== 'default portal'
                );
            this.$nextTick(() => {
              // Safely destroy existing DataTable if it exists
              const table = $('#portal-table').DataTable();
              if ($.fn.DataTable.isDataTable('#portal-table')) {
                table.destroy();
              }
              // Re-initialize
              $('#portal-table').DataTable({
                paging: true,
                searching: true,
                ordering: true,
                info: true,
                lengthChange: true,
                pageLength: 10,
                language: {
                  paginate: {
                    previous: "Previous",
                    next: "Next"
                  },
                  info: "Showing _START_ to _END_ of _TOTAL_ entries",
                  infoEmpty: "No entries available"
                }
              });
              // We target the specific ID for the modal table
              if ($.fn.DataTable.isDataTable('#subPortalTable')) {
                $('#subPortalTable').DataTable().destroy();
              }
              $('#subPortalTable').DataTable({
                paging: true,
                searching: true,
                ordering: true,
                info: true,
                lengthChange: false, // Keep it simple for modals
                pageLength: 10,       // Fewer rows per page for modal view
                language: {
                  paginate: { previous: "Prev", next: "Next" },
                  info: "Showing _START_ to _END_ of _TOTAL_ portals"
                }
              });
            });
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      });
    },


    async deletePortal(portalId) {
      Swal.fire({
        title: 'Are you sure?',
        text: "This action cannot be undone!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        position: 'bottom-end',
        toast: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await fetch(`${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_portal_api/`, {
              method: 'DELETE',
              headers: {
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ portal_id: portalId })
            });

            const data = await response.json();

            if (response.ok) {
              Swal.fire({
                icon: 'success',
                title: 'Deleted!',
                text: data.message || 'Portal has been deleted.',
                showConfirmButton: false,
                timer: 1000,
                position: 'bottom-end',
                toast: true
              }).then(() => {
                this.portals = this.portals.filter(portal => portal.id !== portalId);
              });
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: data.message || 'An error occurred while deleting the portal.',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          } catch (error) {
            const errorData = await error.response.json();

            Swal.fire({
              icon: 'error',
              title: 'Cannot delete portal',
              text:errorData.message,
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          }
          finally {
            this.isLoading = false;
          }
        }
      });
    },
    fetch_users() {
    $.ajax({
      type: 'GET',
      url: process.env.VUE_APP_BACKEND_API_URL + '/system_management/retrieve_users/',
      headers: {
        'Authorization': `Token ${this.getToken()}`,
      },
      success: (response) => {
        // 1. Filter and assign data
        this.users = response.data.users_list.filter(
          user => user.id != this.user_details.user_id
        );

        // 2. Wait for Vue to render the rows, then initialize DataTable
        this.$nextTick(() => {
          // Destroy existing instance if it exists (prevents initialization errors on modal re-open)
          if ($.fn.DataTable.isDataTable('#portalMemberTable')) {
            $('#portalMemberTable').DataTable().destroy();
          }

          $('#portalMemberTable').DataTable({
            paging: true,
            searching: true,
            ordering: true,
            info: true,
            lengthChange: true,
            pageLength: 10,
            language: {
              paginate: {
                previous: "Previous",
                next: "Next"
              },
              info: "Showing _START_ to _END_ of _TOTAL_ entries",
              infoEmpty: "No entries available",
              search: "Search:" // Matches your existing UI intent
            }
          });
        });
      },
    });
  },

  addPortalMembers() {
    if (this.selectedUserIds.length === 0) {
      this.errors.user_ids = "Please select at least one member.";
      return;
    }
    $('#portal_member_modal').modal('hide');
  }
},
  mounted() {
    if (client_domain.includes("chiefluthuli")) {
      this.school_domain = true;
    }
    this.user_details = get_user_details();
    if (this.$route.name === 'create_portal') {
      this.fetch_users();
    }
    this.fecthPortalTypes();
    this.fetchPortals().then(() => {
      this.$nextTick(() => {
        $('.table').DataTable({
          paging: true,
          searching: true,
          ordering: true,
          info: true,
          lengthChange: true,
          pageLength: 10,
          language: {
            paginate: {
              previous: "Previous",
              next: "Next"
            },
            info: "Showing _START_ to _END_ of _TOTAL_ entries",
            infoEmpty: "No entries available"
          },
          sortColumn: '',
          sortDirection: 'asc'
        });
      });
    });
  }
};
